/* @ngInject */
export default function (PreferencesService, moment) {
	return (date) => {
		if (date === null) {
			return null;
		}

		let format = PreferencesService.getDateTimePreference().date;

		return moment(date)
			.format(format);
	};
};


// WEBPACK FOOTER //
// ./src/js/filters/formattedDate.js